import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from '../../globals';
import { ConfigService } from '../../config.service';

@Injectable()
export class GodsviewService {
    private _alldrivers = myGlobals.apiurl + 'godsview/drivers';
    private _alljobs = myGlobals.apiurl + 'dispatcher/driver';
    private _allsearchdrivers = myGlobals.apiurl + 'dispatcher/driverSearch/';
    private _getallCities = myGlobals.apiurl + 'dispatcher/city';
    private _getdriverBasedStatus = myGlobals.apiurl + 'godsview/driversByStatus';
    private _getdriverCount = myGlobals.apiurl + 'godsview/driversCount';

    constructor(
        private _router: Router,
        private _http: HttpClient,
        private _conf: ConfigService) { }

    getdriverCount(user: any) {
        return this._http.post(this._getdriverCount, user, { headers: this._conf.header });
    }

    getdriverBasedStatus(user: any) {
        return this._http.post(this._getdriverBasedStatus, user, { headers: this._conf.header });
    }

    getalldrivers(user: any) {
        return this._http.post(this._alldrivers, user, { headers: this._conf.header });
    }

    getdriverjobs(user: any) {
        return this._http.get(this._alljobs + user.id, { headers: this._conf.header });
    }

    getallcitiesList(user: any) {
        return this._http.get(this._getallCities, { headers: this._conf.header });
    }

    searchDrivers(user: any) {
        return this._http.get(this._allsearchdrivers + user.search, { headers: this._conf.header });
    }
}